import React, { type TextareaHTMLAttributes, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import { length as Length } from "src/shared/forms/validations/Length";
import { required as Required } from "src/shared/forms/validations/Required";

export interface ITermTextInputProps
  extends IFormInputs,
    TextareaHTMLAttributes<HTMLTextAreaElement> {}

export default ({
  inputID,
  label = <FormattedMessage id="content.content_text" />,
  validationDisabled = false,
  cols = 40,
  rows = 6,
  ...rest
}: ITermTextInputProps) => {
  const validation = useMemo(() => {
    if (validationDisabled) {
      return undefined;
    }
    return [Required, Length(1, 2048000)];
  }, [validationDisabled]);

  return (
    <Field
      name={inputID}
      label={label}
      type="textarea"
      component={InputRenderer}
      validate={validation}
      cols={cols}
      rows={rows}
      {...rest}
    />
  );
};
